import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TripDataHub } from "services/signalR/types";

interface signalRModel {
  hubData?: TripDataHub;
}

const initialState: signalRModel = {};

const passengerSignalRSlice = createSlice({
  name: "passengerSignalRSlice",
  initialState,
  reducers: {
    updateData: (state, action: PayloadAction<TripDataHub>) => {
      state.hubData = action.payload;
      return state;
    },
  },
});

export default passengerSignalRSlice;
